@use '../styles/tokens' as *;

.hero {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.heroImage {
  width: 100%;
  height: 180px;
  object-fit: cover;
  object-position: center 60%;
  display: block;

  @include lg {
    height: 270px;
  }
}

.card {
  width: min(930px, calc(100% - 30px));
  margin-top: -60px;
  padding: 30px 25px;
  border-radius: $radius-box;
  background: $white;
  box-shadow: 0 20px 60px rgba(20, 24, 40, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;

  @include lg {
    margin-top: -170px;
    padding: 30px 70px 40px;
  }
}

.icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: block;
}

.title {
  @include text-heading-3;
  color: $blue-gray-2;
  margin: 0;

  @include lg {
    @include text-heading-2;
  }
}

.subtitle {
  @include text-13;
  color: $base-3;
  margin: 0;
}
